import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IParameterMast } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVTextArea } from "../../shared/JVTextarea";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVCheckbox } from "../../shared/JVCheckbox";

const schema = yup.object({
    name: yup.string().trim().required("ParameterMast is required"),
    type: yup.string().required('Parameter Type is required'),
});

interface Iprops {
    singleData: IParameterMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IParameterMast>({
        resolver: yupResolver(schema),
        defaultValues: { isRequired: false, forRequirement: false },
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (body: IParameterMast) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`ParameterMast${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header="Add/Edit ParameterMast" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={1} required label="ParameterMast Name" control={control} name="name" error={errors.name?.message} />
                <JVDropdown required control={control} column={1} label="Type" optionLabel="name" optionValue="id" options={[
                    { id: 'string', name: 'String' },
                    { id: 'number', name: 'Number' },
                ]} name="type" error={errors.type?.message} />
                <JVCheckbox control={control} label="Is Required Field" labelAtTop="IsRequired" name="isRequired" />
                <JVCheckbox control={control} label="For Taking Requirement" labelAtTop="For Requirement" name="forRequirement" />
                <JVTextArea column={1} label="Description" control={control} name="desc" error={errors.desc?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}